import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../../chunks/tslib.es6.js";
import { JSONSupport as o } from "../../../core/JSONSupport.js";
import { property as r } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import { Integer as e } from "../../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../../core/accessorSupport/decorators/subclass.js";
import { getExifValue as n } from "../../../layers/support/exifUtils.js";

var _s;

var p = {
  1: {
    id: 1,
    rotation: 0,
    mirrored: !1
  },
  2: {
    id: 2,
    rotation: 0,
    mirrored: !0
  },
  3: {
    id: 3,
    rotation: 180,
    mirrored: !1
  },
  4: {
    id: 4,
    rotation: 180,
    mirrored: !0
  },
  5: {
    id: 5,
    rotation: -90,
    mirrored: !0
  },
  6: {
    id: 6,
    rotation: 90,
    mirrored: !1
  },
  7: {
    id: 7,
    rotation: 90,
    mirrored: !0
  },
  8: {
    id: 8,
    rotation: -90,
    mirrored: !1
  }
};

var a = _s = /*#__PURE__*/function (_o) {
  _inherits(s, _o);

  var _super = _createSuper(s);

  function s(t) {
    var _this;

    _classCallCheck(this, s);

    _this = _super.call(this, t), _this.contentType = null, _this.exifInfo = null, _this.id = null, _this.globalId = null, _this.keywords = null, _this.name = null, _this.parentGlobalId = null, _this.parentObjectId = null, _this.size = null, _this.url = null;
    return _this;
  }

  _createClass(s, [{
    key: "orientationInfo",
    get: function get() {
      var t = this.exifInfo,
          o = n({
        exifName: "Exif IFD0",
        tagName: "Orientation",
        exifInfo: t
      });
      return p[o] || null;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _s({
        contentType: this.contentType,
        exifInfo: this.exifInfo,
        id: this.id,
        globalId: this.globalId,
        keywords: this.keywords,
        name: this.name,
        parentGlobalId: this.parentGlobalId,
        parentObjectId: this.parentObjectId,
        size: this.size,
        url: this.url
      });
    }
  }]);

  return s;
}(o);

t([r({
  type: String
})], a.prototype, "contentType", void 0), t([r()], a.prototype, "exifInfo", void 0), t([r({
  readOnly: !0
})], a.prototype, "orientationInfo", null), t([r({
  type: e
})], a.prototype, "id", void 0), t([r({
  type: String
})], a.prototype, "globalId", void 0), t([r({
  type: String
})], a.prototype, "keywords", void 0), t([r({
  type: String
})], a.prototype, "name", void 0), t([r({
  json: {
    read: !1
  }
})], a.prototype, "parentGlobalId", void 0), t([r({
  json: {
    read: !1
  }
})], a.prototype, "parentObjectId", void 0), t([r({
  type: e
})], a.prototype, "size", void 0), t([r({
  json: {
    read: !1
  }
})], a.prototype, "url", void 0), a = _s = t([i("esri.layers.support.AttachmentInfo")], a);
var l = a;
export { l as default };